export default "__VITE_ASSET__KK0NAqjN__"